"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _withStyles = _interopRequireDefault(require("../withStyles"));

var _reactTable = _interopRequireDefault(require("react-table"));

var _FilterComponent = _interopRequireDefault(require("./FilterComponent"));

var _Pagination = _interopRequireDefault(require("./Pagination"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/*
 * The <Table /> component extends React-Table with an opinionated default configuration and styles.
 */


var Table =
/*#__PURE__*/
function (_Component) {
  _inherits(Table, _Component);

  function Table() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Table);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Table)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      showFilters: false
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onHideFilters", function () {
      _this.setState({
        showFilters: false
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onShowFilters", function () {
      _this.setState({
        showFilters: true
      });
    });

    return _this;
  }

  _createClass(Table, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          classes = _this$props.classes,
          rest = _objectWithoutProperties(_this$props, ["classes"]);

      var showFilters = this.state.showFilters;
      return _react.default.createElement(_reactTable.default, _extends({
        ref: function ref(r) {
          _this2.innerTable = r;
        },
        getProps: function getProps() {
          return {
            className: classes.root
          };
        },
        getTableProps: function getTableProps() {
          return {
            className: classes.table
          };
        },
        getTheadProps: function getTheadProps() {
          return {
            className: classes.thead
          };
        },
        getTheadTrProps: function getTheadTrProps() {
          return {
            className: (0, _classnames.default)(classes.thead_tr, classes.tr)
          };
        },
        getTheadThProps: function getTheadThProps() {
          return {
            className: (0, _classnames.default)(classes.thead_th, classes.th)
          };
        },
        getTheadGroupProps: function getTheadGroupProps() {
          return {
            className: classes.thead_group
          };
        },
        getTheadGroupTrProps: function getTheadGroupTrProps() {
          return {
            className: classes.thead_group_tr
          };
        },
        getTheadGroupThProps: function getTheadGroupThProps() {
          return {
            className: classes.thead_group_th
          };
        },
        getTheadFilterProps: function getTheadFilterProps() {
          return {
            className: classes.thead_filter,
            style: {
              display: showFilters ? "block" : "none"
            }
          };
        },
        getTheadFilterTrProps: function getTheadFilterTrProps() {
          return {
            className: classes.thead_filter_tr
          };
        },
        getTheadFilterThProps: function getTheadFilterThProps() {
          return {
            className: classes.thead_filter_th,
            tabIndex: ""
          };
        },
        getTbodyProps: function getTbodyProps() {
          return {
            className: classes.tbody
          };
        },
        getTrGroupProps: function getTrGroupProps() {
          return {
            className: classes.tr_group
          };
        },
        getTrProps: function getTrProps() {
          return {
            className: classes.tr
          };
        },
        getThProps: function getThProps() {
          return {
            className: classes.th
          };
        },
        getTdProps: function getTdProps() {
          return {
            className: classes.td
          };
        },
        getTfootProps: function getTfootProps() {
          return {
            className: classes.tfoot
          };
        },
        getTfootTrProps: function getTfootTrProps() {
          return {};
        },
        getTfootThProps: function getTfootThProps() {
          return {};
        },
        getLoadingProps: function getLoadingProps() {
          return {
            className: classes.loading
          };
        },
        getNoDataProps: function getNoDataProps() {
          return {};
        },
        getResizerProps: function getResizerProps() {
          return {
            className: classes.resizer
          };
        },
        defaultFilterMethod: function defaultFilterMethod(filter, row) {
          var id = filter.pivotId || filter.id;
          return row[id] !== undefined ? String(row[id]).toLowerCase().includes(filter.value.toLowerCase()) : true;
        },
        FilterComponent: _FilterComponent.default,
        PaginationComponent: _Pagination.default,
        getPaginationProps: function getPaginationProps() {
          return {
            showFilters: showFilters,
            onHideFilters: _this2.onHideFilters,
            onShowFilters: _this2.onShowFilters
          };
        },
        showPaginationTop: true,
        showPaginationBottom: false
      }, rest));
    }
  }]);

  return Table;
}(_react.Component);

var styles = function styles(theme) {
  return {
    root: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      width: "100%",
      background: theme.colors.white,
      border: "1px solid ".concat(theme.colors.gray200),
      borderRadius: theme.globalBorderRadius,
      "& a[href]": {
        color: theme.colors.secondary["500"],
        textDecoration: "none"
      },
      "& a[href]:hover": {
        color: theme.colors.secondaryDark
      }
    },
    table: {
      flex: "auto 1",
      display: "flex",
      flexDirection: "column",
      alignItems: "stretch",
      width: "100%",
      borderCollapse: "collapse",
      overflow: "auto"
    },
    thead: {
      flex: "1 0 auto",
      display: "flex",
      flexDirection: "column",
      userSelect: "none"
    },
    thead_tr: {
      flex: "1 0 auto",
      display: "inline-flex",
      borderBottom: "1px solid ".concat(theme.colors.gray200)
    },
    thead_th: {
      backgroundRepeat: "no-repeat",
      backgroundSize: "18px 18px",
      backgroundPosition: "right 4px center",
      "&.-cursor-pointer": {
        cursor: "pointer"
      },
      "&.-sort-asc": {
        backgroundImage: "url('data:image/svg+xml;utf8,<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"%23888f96\" d=\"M12.66,3.32l4.16,5.33A.83.83,0,0,1,16.16,10H7.84a.83.83,0,0,1-.66-1.35l4.16-5.33A.84.84,0,0,1,12.66,3.32Z\"/></svg>')"
      },
      "&.-sort-desc": {
        backgroundImage: "url('data:image/svg+xml;utf8,<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"%23888f96\" d=\"M11.34,20.68,7.18,15.35A.83.83,0,0,1,7.84,14h8.32a.83.83,0,0,1,.66,1.35l-4.16,5.33A.84.84,0,0,1,11.34,20.68Z\"/></svg>')"
      }
    },
    thead_group: {},
    thead_group_tr: {},
    thead_group_th: {},
    thead_filter: {
      flex: "1 0 auto",
      display: "flex",
      flexDirection: "column",
      userSelect: "none"
    },
    thead_filter_tr: {
      flex: "1 0 auto",
      display: "flex",
      borderBottom: "1px solid ".concat(theme.colors.gray200)
    },
    thead_filter_th: {
      flex: "1 0 0",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      overflow: "hidden",
      padding: "4px 8px"
    },
    tbody: {
      flex: "99999 1 auto",
      display: "flex",
      flexDirection: "column",
      overflow: "auto"
    },
    tr_group: {
      flex: "1 0 auto",
      display: "flex",
      flexDirection: "column",
      alignItems: "stretch",
      borderBottom: "1px solid ".concat(theme.colors.gray200),
      "&:last-child": {
        borderBottom: "0"
      }
    },
    tr: {
      flex: "1 0 auto",
      display: "inline-flex"
    },
    th: {
      position: "relative",
      flex: "1 0 0",
      color: theme.colors.gray800,
      fontSize: "16px",
      lineHeight: "20px",
      fontWeight: "600",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      overflow: "hidden",
      padding: "10px 8px",
      transition: "0.3s ease",
      transitionProperty: "width, min-width, padding, opacity",
      "&:focus": {
        outline: "1px dotted ".concat(theme.colors.gray400),
        // Modify default focus glow
        outlineOffset: "-4px"
      },
      "&.-hidden": {
        width: "0 !important",
        minWidth: "0 !important",
        padding: "0 !important",
        border: "0 !important",
        opacity: "0 !important"
      }
    },
    td: {
      flex: "1 0 0",
      fontSize: "16px",
      lineHeight: "20px",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      overflow: "hidden",
      padding: "10px 8px",
      transition: "0.3s ease",
      transitionProperty: "width, min-width, padding, opacity",
      "&.-hidden": {
        width: "0 !important",
        minWidth: "0 !important",
        padding: "0 !important",
        border: "0 !important",
        opacity: "0 !important"
      }
    },
    tfoot: {
      flex: "1 0 auto",
      display: "flex",
      flexDirection: "column"
    },
    loading: {
      display: "block",
      position: "absolute",
      left: "0",
      right: "0",
      top: "0",
      bottom: "0",
      background: "rgba(255, 255, 255, 0.8)",
      transition: "all 0.3s ease",
      zIndex: theme.zIndex["tableLoading"],
      opacity: "0",
      pointerEvents: "none",
      "&.-active": {
        opacity: "1",
        zIndex: theme.zIndex["tableLoadingActive"],
        pointerEvents: "all",
        "& > div": {
          transform: "translateY(50%)"
        }
      },
      "& > div": {
        position: "absolute",
        display: "block",
        textAlign: "center",
        width: "100%",
        top: "50%",
        left: "0",
        fontSize: "14px",
        color: "rgba(0, 0, 0, 0.6)",
        transform: "translateY(-52%)",
        transition: "all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)"
      }
    },
    resizer: {
      display: "inline-block",
      position: "absolute",
      width: "24px",
      top: "0",
      bottom: "0",
      right: "-12px",
      cursor: "col-resize",
      userSelect: "none",
      zIndex: theme.zIndex["tableResizer"]
    }
  };
};

var _default = (0, _withStyles.default)(styles, {
  name: "EuiTable"
})(Table);

exports.default = _default;